import SnackbarService from "@/services/snackbar-service";
import RouterService from "@/services/router-service";
import Translator from "@/types/services/Translator";
import EsquireService from "@/services/esquire-service";
import ReservationExtensionService from "@/services/reservation-extension-service";
import DateService from "@/services/date-service";
import PaymentService from "@/services/payment-service";
import PassportService from "@/services/passport-service";
import FileService from "@/services/file-service";
import {ChatwootService} from "@/services/chatwoot-service";
import CheckinFlowTrackingService from "@/services/checkin-flow-tracking-service";

class GlobalService {
  date() {
    return DateService;
  }

  esquire() {
    return EsquireService;
  }

  file() {
    return FileService;
  }

  chatwoot() {
    return ChatwootService;
  }

  checkinFlow() {
    return CheckinFlowTrackingService;
  }

  passport() {
    return PassportService;
  }
  payment(){
    return PaymentService;
  }
  reservationExtension() {
    return ReservationExtensionService;
  }
  router() {
    return RouterService;
  }
  snackbar() {
    return SnackbarService;
  }
  translator() {
    return Translator;
  }

}

export default new GlobalService();
